import gql from 'graphql-tag'

export default gql`mutation go($data: UserRoleInput!){
  upsert_user_role_with_permissions(data: $data){
    user_role_id
    description
    permissions {
      permission_id
      access
    }
  }
}`